/*
 * @Author: Src
 * @Date: 2025-07-15 09:56:56
 * @LastEditTime: 2025-08-12 15:24:33
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/carRouter/carListRoutes.ts
 * @Description: 头部注释配置模板
 */
import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';
// import CarList from '@/views/carModule/carList/carList.vue';
import CarList from '@/views/carModule/car/carList.vue';
import { AuthEnum } from '@/services/permission.service';

const carShopRoutes: RouteConfig = {
  path: '/car',
  component: Main,
  redirect: {
    name: 'carlist.index',
  },
  meta: {
    title: '车辆列表',
  },
  children: [
    {
      name: 'carlist.index',
      path: '/car/list/:id',
      component: CarList,
      props: {
        routeType: 'usedCar',
        auth: [AuthEnum.二手车店铺列表],
      },
      meta: {
        title: '车辆列表',
      },
    },
  ],
};

export default carShopRoutes;
